import { ApiError } from '../../api/client.js';

export function problem(e) {
  if (e?.code === 'offline') return 'No connection. Match-Ups can only be changed online.';
  if (e instanceof ApiError) return e.message;
  return 'Something went wrong. Try again.';
}

// "6 a day", "3.5 a day", or "No target".
export function targetText(t) {
  if (!t || t.value === null) return 'No target';
  return `${t.value} a day`;
}

// Each team's colour, by team id order, so a team keeps its colour on every
// screen (Match-Ups rows, the bookings calendar).
const TEAM_COLOURS = ['#29ABE2', '#D9A400', '#7B61FF', '#E5533D', '#1E9E6A', '#D63384', '#0B6E99', '#8A5A00'];
export function teamColours(teams = []) {
  const ids = teams.map((t) => t.id).sort((a, b) => a - b);
  return new Map(ids.map((id, i) => [id, TEAM_COLOURS[i % TEAM_COLOURS.length]]));
}
